module.exports = __webpack_public_path__ + "static/media/fci_animals_form_last.cc6476b6.png";